import React from "react";
import TestObject from "@learningblocks/protocol-components/lib/TestObject";
// import { MicroPipette } from "../../PhotosynthesisComponents/MicroPipette";
import MicroPipette from "@learningblocks/simulations/shared-components/lib/Pipette";

class ComponentFactory {
  private static instance: ComponentFactory;

  private constructor() {
    //Intentionally empty
  }

  public static getInstance(): ComponentFactory {
    if (!this.instance) this.instance = new ComponentFactory();
    return this.instance;
  }

  getComponent(componentName: string, id: string, additionalProps?: any) {
    switch (componentName) {
      case "pipette": {
        const modal = <MicroPipette id={id} {...additionalProps} />;
        return modal;
      }
      case "TestObject": {
        const modal = <TestObject />;
        return modal;
      }
      default: {
        return null;
      }
    }
  }
}

export default ComponentFactory;
